import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/common/Blocks";

export default function NotFoundPage() {
  return (
    <div className="page">
      <EmptyState
        icon={Compass}
        title="Siden finnes ikke"
        description="Lenken kan være feil, eller eksempeldataene er tilbakestilt."
        action={<Button asChild><Link to="/oversikt" data-testid="notfound-home-link">Til oversikten</Link></Button>}
      />
    </div>
  );
}
